var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4992 10.6421V17.7807M8.74014 10.6421V17.7807M3.98109 5.88307V20.1602C3.98109 20.7913 4.23179 21.3966 4.67803 21.8428C5.12428 22.2891 5.72952 22.5398 6.36061 22.5398H15.8787C16.5098 22.5398 17.115 22.2891 17.5613 21.8428C18.0075 21.3966 18.2582 20.7913 18.2582 20.1602V5.88307M1.60156 5.88307H20.6378M5.17085 5.88307L7.55037 1.12402H14.6889L17.0685 5.88307",
    stroke: "#E80000",
    strokeWidth: 1.42772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteUser);
export default __webpack_public_path__ + "static/media/delete-user.2a4f6c0ac1d9564d0d5b23c6032ab9a2.svg";
export { ForwardRef as ReactComponent };